"use strict";
import "regenerator-runtime/runtime";
import React from "react";
import { createRoot } from "react-dom/client";
import './styles/global.scss';
import AppWrapper from './AppWrapper';

// render the React app
const renderApp = (container) => {
	const root = createRoot(container);
	root.render(<AppWrapper />);
};

// wait for the container to be available
const waitForContainer = (callback) => {
	const interval = setInterval(() => {
		const container = document.querySelector('#page_content');
		console.log('before');
		if (container) {
			console.log('after');
			clearInterval(interval);
			callback(container);
		}
	}, 100); // Check every 100ms
};

// Check if the user agent is a mobile device
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

if (isMobile) {
	// for mobile web, directly call the container check
	waitForContainer(renderApp);
} else {
	// for web, use `DOMContentLoaded`
	document.addEventListener("DOMContentLoaded", () => {
		waitForContainer(renderApp);
	});
}